module.exports = __webpack_public_path__ + "static/media/QuizzAppFirst.14d708cc.PNG";